module.exports = __webpack_public_path__ + "static/media/Carlmontlogo.077dc9fa.jpg";